import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createIndicatorCategory = createAsyncThunk("createIndicatorCategory", async ({ data }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.post(`vision/category/create`, data, config);
	message.success("Indicator Category successfully created!");
	return response.data;
});

const indicatorCategoryCreateSlice = createSlice({
	name: "indicatorCategoryCreate",
	initialState: {
		isLoading: false,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(createIndicatorCategory.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(createIndicatorCategory.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(createIndicatorCategory.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default indicatorCategoryCreateSlice.reducer;
